import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';



export function RootLayout() {
  return (
    <>
        <div className='global_container'>
          <Header />
          {/* <div className="side_bar_outlet_contain"> */}
          {/* <SideBar /> */}
          <div className='outlet_contain'>
            <Outlet />
          </div>
          <Footer />
          {/* </div> */}
        </div>
    </>
  );
}